var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useCallback } from 'react';
import { css, styled } from "../../utils";
import { Label, OptionalTag, InputHintError } from './Addons/';
var textStyle = function (_a) {
    var colors = _a.colors, fonts = _a.fonts, fontWeights = _a.fontWeights;
    return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  font-size: 1.125rem;\n  letter-spacing: 0.08rem;\n  font-family: ", ";\n  color: ", ";\n  font-weight: ", ";\n"], ["\n  font-size: 1.125rem;\n  letter-spacing: 0.08rem;\n  font-family: ", ";\n  color: ", ";\n  font-weight: ", ";\n"])), fonts.primary, colors.primary, fontWeights.medium);
};
var Container = styled.div(function (_a) {
    var theme = _a.theme, _b = _a.theme, colors = _b.colors, space = _b.space;
    return css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    ", ";\n    position: relative;\n    display: inline-block;\n    width: 100%;\n\n    textarea {\n      ", ";\n      border-radius: ", "px;\n      border: 1px solid ", ";\n      background-color: ", ";\n      padding: ", " ", ";\n      box-sizing: border-box;\n      outline: none;\n      caret-color: ", ";\n      resize: none;\n      width: 100%;\n\n      &:focus,\n      &:focus-visible {\n        outline: 3px solid ", ";\n      }\n    }\n\n    p,\n    .InputHintError {\n      margin-left: ", ";\n    }\n  "], ["\n    ", ";\n    position: relative;\n    display: inline-block;\n    width: 100%;\n\n    textarea {\n      ", ";\n      border-radius: ", "px;\n      border: 1px solid ", ";\n      background-color: ", ";\n      padding: ", " ", ";\n      box-sizing: border-box;\n      outline: none;\n      caret-color: ", ";\n      resize: none;\n      width: 100%;\n\n      &:focus,\n      &:focus-visible {\n        outline: 3px solid ", ";\n      }\n    }\n\n    p,\n    .InputHintError {\n      margin-left: ", ";\n    }\n  "])), textStyle(theme), textStyle(theme), theme.radii[2], colors.primary, theme.colors.secondary, space[3], space[6], colors.primary, colors.primary, space.large);
});
var Textarea = function (_a) {
    var initialValue = _a.value, label = _a.label, onChange = _a.onChange, extra = _a.extra, className = _a.className, optional = _a.optional, error = _a.error, validation = _a.validation, props = __rest(_a, ["value", "label", "onChange", "extra", "className", "optional", "error", "validation"]);
    var handleChange = useCallback(function (e) {
        onChange && onChange(e);
    }, [onChange]);
    return (React.createElement(Container, { "data-component": "Textarea", className: className },
        label && (React.createElement(Label, { ml: "large" },
            label,
            optional && React.createElement(OptionalTag, null))),
        React.createElement("textarea", __assign({}, props, { value: initialValue, onChange: handleChange })),
        React.createElement(InputHintError, { error: error, hint: extra, validation: validation })));
};
export default Textarea;
var templateObject_1, templateObject_2;
//# sourceMappingURL=Textarea.js.map